
import { Assessment } from '@/types/assessment';
import { getAssessmentById, updateAssessment, publishAssessment } from '@/services/assessment';

export async function fetchAssessment(id: string): Promise<Assessment | null> {
  try {
    return await getAssessmentById(id);
  } catch (error) {
    console.error('Error fetching assessment:', error);
    return null;
  }
}

export async function saveAssessmentSettings(
  id: string,
  data: Partial<Assessment>
): Promise<Assessment | null> {
  try {
    return await updateAssessment(id, data);
  } catch (error) {
    console.error('Error updating assessment settings:', error);
    return null;
  }
}

export async function saveAssessmentContent(
  id: string,
  data: Partial<Assessment>
): Promise<Assessment | null> {
  try {
    return await updateAssessment(id, data);
  } catch (error) {
    console.error('Error updating assessment content:', error);
    return null;
  }
}

export async function publishAssessmentToLive(
  id: string
): Promise<Assessment | null> {
  try {
    return await publishAssessment(id);
  } catch (error) {
    console.error('Error publishing assessment:', error);
    return null;
  }
}
